import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import PayWithButtonGroup from 'components/PayWithButtonGroup';
import { getQueryPayWith, getQueryMinPrice, getQueryMaxPrice } from 'store/search/searchSelectors/querySelectors';
import { updateQuery as updateQueryAction } from 'store/search/searchActions';

const PayWith = ({ options, name, ...rest }) => {
  const payWith = useSelector(getQueryPayWith);
  const minPrice = useSelector(getQueryMinPrice);
  const maxPrice = useSelector(getQueryMaxPrice);
  const dispatch = useDispatch();

  const updateQuery = useCallback(
    (query) => {
      dispatch(updateQueryAction(query));
    },
    [dispatch],
  );

  return (
    <PayWithButtonGroup
      {...rest}
      options={options}
      name={name}
      payWith={payWith}
      minPrice={minPrice}
      maxPrice={maxPrice}
      updateQuery={updateQuery}
    />
  );
};

PayWith.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default PayWith;
